<template>
  <div class="home" id="div_home" v-if="rol != null">
    <div class="" v-if="campus != null">
      <div v-if="rol == 1" class="">
        <GerenciaComponent @mtdBackCampus="mtdBackCampus" :rolname="rolname" :dataRoles="dataRoles"/>
      </div>
      <div v-else-if="rol == 2" class="">
        <AdmisionComponet :rolname="rolname" @mtdBackCampus="mtdBackCampus"/>
      </div>      
      <div v-else-if="rol == 6" class="">
        <LogisticaComponent :rolname="rolname" @mtdBackCampus="mtdBackCampus" />
      </div>
      <!-- <div v-else-if="rol == 8" class="">
        <AdministracionComponent @mtdBackCampus="mtdBackCampus" :rolname="rolname" :dataRoles="dataRoles" />
      </div> -->
      <!-- <div v-else-if="rol == 9" class="">
        <JefeAdmisionComponent :rolname="rolname" @mtdBackCampus="mtdBackCampus" />
      </div> -->
      <!-- <div v-else-if="rol == 10" class="">
        <FarmaciaComponent :rolname="rolname" @mtdBackCampus="mtdBackCampus"/>
      </div> -->
      <!-- <div v-else-if="rol == 11" class="">
        <RhComponent :rolname="rolname" @mtdBackCampus="mtdBackCampus"/>
      </div> -->
      <div v-else-if="rol == 5" class="">
        <TesoreriaComponent :rolname="rolname" @mtdBackCampus="mtdBackCampus"/>
      </div>
      <!-- <div v-else-if="rol == 13" class="">
        <FacturacionComponent :rolname="rolname" @mtdBackCampus="mtdBackCampus"/>
      </div> -->
      <!-- <div v-else-if="rol == 14" class="">
        <DirectorComponent :rolname="rolname" @mtdBackCampus="mtdBackCampus" />
      </div> -->
      <!-- <div v-else-if="rol == 15" class="">
        <LimpiezaComponent :rolname="rolname" @mtdBackCampus="mtdBackCampus" />
      </div> -->
      <!-- <div v-else-if="rol == 17" class="">
        <MarketingComponent :rolname="rolname" @mtdBackCampus="mtdBackCampus" />
      </div> -->
      <!-- <div v-else-if="rol == 18" class="">
        <JefaEnfermeriaComponent :rolname="rolname" @mtdBackCampus="mtdBackCampus" />
      </div> -->
      <!-- <div v-else-if="rol == 19" class="">
        <GerenciaGeneralView :rolname="rolname" @mtdBackCampus="mtdBackCampus"  :dataRoles="dataRoles" />
      </div> -->
      <!-- <div v-else-if="rol == 20" class="">
        <ProveedorView :rolname="rolname" @mtdBackCampus="mtdBackCampus" />
      </div> -->
    </div>
    <div v-else-if="rol == 3" class="">
        <MaintenanceComponent  @mtdBackRol="mtdBackRol" :rolname="rolname" />
      </div>
    <div class="" v-else>
      <CampusComponent
        :dataRoles="dataRoles"
        :dataCampus="dataCampus"
        @mtdSelectCampus="mtdSelectCampus"
        @mtdBackRol="mtdBackRol"
      />
    </div>
  </div>
  <div class="" v-else>
    <RolesVue :dataRoles="dataRoles" @mtdSelectRol="mtdSelectRol" v-if="page != 'tareas_asignadas'"/>
    <FooterVue  @mtdChangePage="mtdChangePage" :pageView="page" @mtdBackCampus="mtdBackCampus" />
    <TareasVue v-if="page == 'tareas_asignadas'"  @mtdChangePage="mtdChangePage"  />
  </div>
</template>

<script>
import CampusComponent from "./Campus/index.vue";
import RolesVue from "./Rol/index.vue";
import GerenciaComponent from './Gerencia/GerenciaView.vue';
import MaintenanceComponent from "./Maintenance/MaintenanceView.vue";
import LogisticaComponent from './Logistica/LogisticaView.vue';
import AdmisionComponet from './Admision/AdmisionView.vue'
import TesoreriaComponent from "./Tesoreria/TesoreriaView.vue";
import FooterVue from "@/views/FooterView.vue";
import TareasVue from "../components/Tareas/Tareas.vue";

import { mapActions } from 'vuex'

export default {
  name: 'HomeView',
  components: {
    CampusComponent,
    RolesVue,
    GerenciaComponent,
    MaintenanceComponent,
    LogisticaComponent,
    AdmisionComponet,
    TesoreriaComponent,
    FooterVue,
    TareasVue,
  },
  data () {
    return {
      page: "home",
      rol: null,
      rolname: null,
      dataCampus: [],
      campus: null,
      dataRoles: [],
    }
  },
  created () {
    const user = this.$store.getters.get__user

    if (user.roles.length == 1) {
      this.rol = user.roles[0].role_id;
      this.rolname = user.roles[0].role.name;
    } else {
      this.dataRoles = user.roles;
      this.rolname = '';
    }
    this.dataCampus = this.$store.getters.get__datacampus;
    this.mtdgetcheck();
  },
  methods: {
    ...mapActions(['get', 'post']),

    mtdSelectCampus: function (id) {
      this.campus = id;
      this.$store.commit("mt_set_campus", id);
    },
    mtdSelectRol: function (id, name_rol) {
      this.rol = id;
      this.rolname = name_rol;
      this.mtdgetcheck();
    },
    mtdBackRol: function () {
      this.rol = null;
    },
    mtdBackCampus: function () {
      this.campus = null;
      this.$store.commit("mt_set_campus", null);
    },
    mtdgetcheck: function () {
      const user = this.$store.getters.get__user
      this.get({
          url: this.$store.getters.get__url + "/Authentication/check",
          token: this.$store.getters.get__token,
        })
        .then((response) => {
          this.check = response.data.check;
          if(this.check){
            if(this.rol == 1){
              this.$router.push('/gerente')
            }else
            if(this.rol == 2){
              this.$router.push('/ventas')
            }else
            if(this.rol == 3){
              this.$router.push('/maintenance')
            }else
            if(this.rol == 4){
              this.$router.push('/contabilidad')
            }else
            if(this.rol == 5){
              this.$router.push('/tesoreria')
            }else
            if(this.rol == 6){
              this.$router.push('/logistica')
            }
          }
        })
    },
    mtdChangePage: function (page) {
      this.page = page;
    },
  }
}
</script>